/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from "react";
import { Row, Col, Button, Skeleton, message, Spin } from "antd";
import { Link, useParams, useHistory } from "react-router-dom";
import { LeftOutlined } from "@ant-design/icons";
import crypto from "crypto-js";
import axios from "axios";
import firebase from "../../../config/FirebaseConfig";
import Layout from "../../../layout/Dashboard";
import "./Detail.css";

export default function Detail() {
  const BASE_URL = "https://carenting-server.herokuapp.com";
  const { id } = useParams();
  const history = useHistory();
  const [detail, setDetail] = useState({});
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(false);

  useEffect(() => {
    const fetchData = () => {
      firebase
        .firestore()
        .collection("temp")
        .doc(id)
        .get()
        .then((doc) => {
          if (!doc.exists) {
            message.error("Tidak terdapat data seperti ini");
          } else {
            setDetail({
              id: doc.id,
              ...doc.data(),
            });
            setLoading(false);
          }
        })
        .catch((err) => {
          console.log(err);
          message.error("Kesalahan pada saat mengambil data");
        });
    };
    fetchData();
  }, [id]);

  const handleTolak = () => {
    setActionLoading(true);
    Promise.all([
      firebase.firestore().collection("temp").doc(id).delete(),
      axios.get(
        `${BASE_URL}/rejected?name=${detail.name}&receiver=${detail.email}`
      ),
    ])
      .then(() => {
        setActionLoading(false);
        message.success("Aksi berhasil");
        history.push("/dashboard/psikolog");
      })
      .catch((err) => {
        setActionLoading(false);
        console.log(err);
        message.error("Terjadi kesalahan");
      });
  };

  const handleTerima = () => {
    setActionLoading(true);
    const bytes = crypto.AES.decrypt(detail.password, "!@#Carenting");
    const password = bytes.toString(crypto.enc.Utf8);

    firebase
      .auth()
      .createUserWithEmailAndPassword(detail.email, password)
      .then((doc) => {
        let uid = doc.user.uid;
        Promise.all([
          firebase
            .firestore()
            .collection("psikolog")
            .doc(uid)
            .set({
              ...detail,
              id: uid,
            }),
          firebase.firestore().collection("temp").doc(id).delete(),
          axios.get(
            `${BASE_URL}/accepted?name=${detail.name}&receiver=${detail.email}`
          ),
        ])
          .then(() => {
            setActionLoading(false);
            message.success("Aksi berhasil");
            history.push("/dashboard/psikolog");
          })
          .catch((err) => {
            setActionLoading(false);
            console.log(err);
            message.error("Terjadi kesalahan");
          });
      })
      .catch((err) => {
        setActionLoading(false);
        message.error("Terjadi kesalahan");
        console.log(err);
      });
  };

  return (
    <Layout>
      <div id="detail_psikolog">
        <div className="navbar">
          <Link to="/dashboard/psikolog">
            <LeftOutlined /> &nbsp; <span>Detail</span>
          </Link>
        </div>
        <Row justify="end" align="middle">
          <Col
            style={{
              marginRight: 24,
            }}
          >
            <Button className="button_primary" onClick={handleTolak}>
              {actionLoading ? <Spin /> : "Tolak"}
            </Button>
          </Col>
          <Col>
            <Button className="button_secondary" onClick={handleTerima}>
              {actionLoading ? <Spin /> : "Verifikasi"}
            </Button>
          </Col>
        </Row>
        <Skeleton loading={loading}>
          <Row justify="space-around" align="top">
            <Col span={12}>
              <div className="detail">
                <div className="label">Nama</div>
                <div className="data">{detail.name}</div>
              </div>
              <div className="detail">
                <div className="label">Email</div>
                <div className="data">{detail.email}</div>
              </div>
              <div className="detail">
                <div className="label">No. HP</div>
                <div className="data">{detail.phoneNumber}</div>
              </div>
              <div className="detail">
                <div className="label">Alamat</div>
                <div className="data">{detail.address}</div>
              </div>
            </Col>
            <Col span={12}>
              <div className="detail">
                <div className="label">No Identitas</div>
                <div className="data">{detail.IDCardNumber}</div>
              </div>
              <div className="detail">
                <div className="label">Tahun Pertama Praktek</div>
                <div className="data">{detail.experience}</div>
              </div>
              <div className="detail">
                <div className="label">Surat Izin Praktek</div>
                <a target="_blank" href={detail.sip} className="data">
                  Surat Izin Praktek
                </a>
              </div>
              <div className="detail">
                <div className="label">Ijazah Terakhir</div>
                <a target="_blank" href={detail.certificate} className="data">
                  Ijazah Terakhir
                </a>
              </div>
            </Col>
          </Row>
        </Skeleton>
      </div>
    </Layout>
  );
}
